/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Group_Rewards_LedeInputs */



/**
* | output |
* | --- |
* | "Perks worth chasing, kept in step by Colossus." |
*
* @param {Products_Group_Rewards_LedeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_group_rewards_lede = /** @type {((inputs?: Products_Group_Rewards_LedeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Group_Rewards_LedeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Привилегии, за которыми стоит гнаться, — Colossus держит их в порядке.")
	return /** @type {LocalizedString} */ ("Perks worth chasing, kept in step by Colossus.")
});